var $1f7e1cf2285af2b2$exports = {};
$1f7e1cf2285af2b2$exports = {
    "Clear search": `Aramay\u{131} temizle`
};


export {$1f7e1cf2285af2b2$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
